@if (themeService.currentTheme === 'dark') {
  <div>
    <dx-button
      class="theme-button"
      stylingMode="text"
      [icon]="'fas fa-moon'"
      (onClick)="onButtonClick()"
    ></dx-button>
  </div>
}
@if (themeService.currentTheme !== 'dark') {
  <div>
    <dx-button
      class="theme-button"
      stylingMode="text"
      [icon]="'fas fa-sun'"
      (onClick)="onButtonClick()"
    ></dx-button>
  </div>
}
